import React from "react";
function Image({ image }) {
  return (
    <>
      <img alt={image.key} src={image.src} width='100'/>
    </>
  );
}
export default Image;